import React, { useContext } from "react";
import { useState, useEffect } from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import "../../src/styles/Login.css";
import Logo from "../../src/elmanassa logo.png";
import "../styles/Login.css"; // Import the CSS file for styling
import BASE_URL from "../BaseUrl.jsx"; // Import the base URL
import CircularProgress from '@mui/material/CircularProgress';
import { GlobalContext } from "./GlobalContext.jsx";

export default function LogIn({setActive, pagesOut, setPagesOut}) {
  const {setAdmin} = useContext(GlobalContext);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [acceptedInputs, setAcceptedInputs] = useState(true);
  const [disabledButton, setDisabledButton] = useState(false);

    const [user, setUser] = useState({
        email: "",
        password: "",
    });

  const forbiddenPattern = /[<>/{}/=]/;
  const forbiddenSQL = /\b(SELECT|INSERT|UPDATE|DELETE|DROP|ALTER|CREATE|TRUNCATE|EXEC|UNION)\b/i;

  const checkInput = (e) => {
    const inputValue = e.target.value;
    if (forbiddenPattern.test(inputValue) || forbiddenSQL.test(inputValue)) {
      setAcceptedInputs(false);
      e.target.style.borderColor = "red";
    } else{
      setAcceptedInputs(true);
    }
  };


    
    const handleChange = (e) => {
      e.target.style.border= "var(--bs-border-width) solid var(--bs-border-color)";
      checkInput(e);
      setUser({ ...user, [e.target.name]: e.target.value });
    };

  useEffect(() => {
    axios
      .get(BASE_URL+"/auth/check-auth", { withCredentials: true })
      .then((response) => {
        if(response.data === "not loged in") return;
        setPagesOut({
        logInOut: true,
        homeOut: false,
        servicesOut: false,
        constactOut:false
    })
        setTimeout(()=>{
          if(response.data.type === "OWNER"){
            navigate("/owner-home");
          }
          else if(response.data.type === "ADMIN"){
            setAdmin(response.data.person);
            navigate("/admin-home", {state:{admin: response.data.person}});  
          }else if(response.data.type === "ASSISTANT"){
            setAdmin(response.data.person);
            navigate("/assistant-home", {state:{admin: response.data.person}});  
          }
        },500)
      })
      .catch((error) => {
        console.error("There was an error checking authentication!", error.message);
      });
      setActive("تسجيل الدخول");
  }, []);

    const sendData = (e) =>{
      setDisabledButton(true);
      if(!acceptedInputs){
        setDisabledButton(false);
        return;
      }
        e.preventDefault();
        axios.post(BASE_URL+"/auth/login", user,{withCredentials: true})
            .then((response) => {
                setPagesOut({
                    logInOut: true,
                    homeOut: false,
                    servicesOut: false,
                    constactOut:false
                })
                setTimeout(()=>{
                  if(response.data.type === "OWNER"){
                    navigate("/owner-home");
                  }
                  else if(response.data.type === "ADMIN"){
                        navigate("/admin-home", {state:{admin: response.data.person}});
                  }
                  else if(response.data.type === "ASSISTANT"){
                        navigate("/assistant-home", {state:{admin: response.data.person}});
                  }
                },500)
                
            })
            .catch((error) => {
              if(error.response === undefined){
                  setError(error.message);
                }
                else if(error.response.status === 404 || error.response.status === 401){
                    setError(error.response.data);
                }
                setShowPopup(true);
                setDisabledButton(false);
            });
    }

  return (
    <div>
      
    <div className="login-container">
      
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 log-in">
    <img className="log-in-logo" src={Logo} alt="no"/>
      <div className={`log-in-form-div ${pagesOut.logInOut? "log-in-form-out": ""}`}>
        <h1 className=" fw-bold mb-4">تسجيل الدخول</h1>
        <form className="w-100" style={{ maxWidth: "400px" }}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              البريد الالكتروني
            </label>
            <input
              type="text"
              className="form-control"
              id="email"
              placeholder="xxxxx@gmail.com"
              name="email"
              onChange={(e)=>handleChange(e)}
            />
          </div>
          <div className="mb-4">
            <label htmlFor="password" className="form-label">
              كلمة المرور
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="************"
              name="password"
              onChange={(e)=>handleChange(e)}
            />
          </div>
          
              
            <button type="button"
            disabled={disabledButton}
            onClick={(e)=>{sendData(e)}}  className="btn btn-primary log-in-button">
              {disabledButton ? <CircularProgress size={24} color="white" /> : "تسجيل الدخول"}
            </button>
          <div className="registration-div">
            <a href="forgot-password">نسيت كلمة المرور؟</a>
            <br/>
            <a href="register">ليس لديك حساب؟تسجيل..</a>
          </div>
          
        </form>
      </div>
    </div>
    {showPopup && (
        <div className="login-popup-overlay">
          <div className="login-popup">
            <h2>تعذر تسجيل الدخول</h2>
            <p>{error}</p>
            <button onClick={() => setShowPopup(false)} className="btn btn-danger">
              إغلاق
            </button>
          </div>
        </div>
      )}
    </div>

    </div>
  );
}
